/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

var _reduxModulesSubscribeModal = require('redux/modules/subscribeModal');

var SiteFooter = (function (_Component) {
	_inherits(SiteFooter, _Component);

	function SiteFooter() {
		var _this2 = this;

		_classCallCheck(this, _SiteFooter);

		_Component.apply(this, arguments);

		this.state = {
			creditsAreVisible: false,
			isSmallViewport: false
		};

		this.toggleCredits = function (event) {
			event.preventDefault();
			_this2.setState({
				creditsAreVisible: !_this2.state.creditsAreVisible
			});
		};
	}

	SiteFooter.prototype.componentDidMount = function componentDidMount() {
		var _this = this;
		var enquire = require('../../../static/js/enquire');
		enquire.register('(min-width:0px) and (max-width:' + _srcSettings2['default'].media.small + ')', {
			match: function match() {
				_this.setState({ isSmallViewport: true });
			},
			unmatch: function unmatch() {
				_this.setState({ isSmallViewport: false });
			}
		});
	};

	SiteFooter.prototype.render = function render() {
		var _classNames;

		var styles = require('./SiteFooter.css');

		var creditClasses = _classnames2['default']((_classNames = {}, _classNames[styles.CreditsLink] = true, _classNames[styles['CreditsLink--isOpen']] = this.state.creditsAreVisible, _classNames));

		var sections = _lodashMap2['default'](this.props.sections, function (item, id) {
			return _react2['default'].createElement(
				'li',
				{ className: styles.NavItem, key: id },
				_react2['default'].createElement(_reactRouter.Link, { className: styles.Link, to: '/section/' + item.slug, dangerouslySetInnerHTML: { __html: item.name || item.title.rendered } })
			);
		});

		return _react2['default'].createElement(
			'footer',
			{ className: styles.Base },
			!this.state.isSmallViewport && _react2['default'].createElement(
				'nav',
				{ className: styles.NavWrapper },
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'ul',
						{ className: styles.Nav },
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/' },
								'Front Page'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/special-series' },
								'Special Series'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/section/daily-drip' },
								'The Drip'
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'ul',
						{ className: styles.Nav },
						sections
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'ul',
						{ className: styles.Nav },
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/about' },
								'About The Brew'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/contributors' },
								'Contributors'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/contact' },
								'Contact'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/page/advertise' },
								'Advertise'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/page/legal' },
								'Legal/Privacy'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/membership' },
								'Membership'
							)
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'fieldset',
						{ className: styles.Newsletter },
						_react2['default'].createElement(
							'legend',
							{ className: styles.Legend },
							'Get Our Newsletter:'
						),
						_react2['default'].createElement(
							'button',
							{ className: styles.Button, onClick: this.props.open },
							'Subscribe'
						)
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Credits },
					_react2['default'].createElement(
						'div',
						{ className: styles.CreditsWrapper },
						_react2['default'].createElement(
							'a',
							{ className: creditClasses, href: '#credits', onClick: this.toggleCredits },
							'Site Credits'
						),
						this.state.creditsAreVisible && _react2['default'].createElement(
							'div',
							{ className: styles.CreditsContent },
							_react2['default'].createElement(
								'a',
								{ href: 'http://posttypography.com', target: '_blank' },
								'Website by Post Typography and Brandon Durham'
							),
							_react2['default'].createElement('br', null),
							_react2['default'].createElement('br', null),
							_react2['default'].createElement(
								'a',
								{ href: 'http://madewithloveinbaltimore.org/', target: '_blank' },
								'Made with ♥ in Baltimore'
							)
						)
					)
				)
			),
			this.state.isSmallViewport && _react2['default'].createElement(
				'nav',
				{ className: styles.NavWrapper },
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'ul',
						{ className: styles.Nav },
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/' },
								'Front Page'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/special-series' },
								'Special Series'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/section/daily-drip' },
								'The Drip'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles['NavItem--withDivider'] },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/' },
								'Politics'
							)
						),
						sections
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Column },
					_react2['default'].createElement(
						'ul',
						{ className: styles.Nav },
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/about' },
								'About The Brew'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/contributors' },
								'Contributors'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/contact' },
								'Contact'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/page/advertise' },
								'Advertise'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/page/legal' },
								'Legal/Privacy'
							)
						),
						_react2['default'].createElement(
							'li',
							{ className: styles.NavItem },
							_react2['default'].createElement(
								_reactRouter.Link,
								{ className: styles.Link, to: '/membership' },
								'Membership'
							)
						)
					),
					_react2['default'].createElement(
						'div',
						{ className: styles.Credits },
						_react2['default'].createElement(
							'div',
							{ className: styles.CreditsWrapper },
							_react2['default'].createElement(
								'a',
								{ className: creditClasses, href: '#credits', onClick: this.toggleCredits },
								'Site Credits'
							),
							this.state.creditsAreVisible && _react2['default'].createElement(
								'div',
								{ className: styles.CreditsContent },
								_react2['default'].createElement(
									'a',
									{ href: 'http://posttypography.com', target: '_blank' },
									'Website by Post Typography and Brandon Durham'
								),
								_react2['default'].createElement('br', null),
								_react2['default'].createElement('br', null),
								_react2['default'].createElement(
									'a',
									{ href: 'http://madewithloveinbaltimore.org/', target: '_blank' },
									'Made with ♥ in Baltimore'
								)
							)
						)
					)
				)
			)
		);
	};

	_createClass(SiteFooter, null, [{
		key: 'propTypes',
		value: {
			links: _react.PropTypes.array,
			open: _react.PropTypes.func.isRequired,
			sections: _react.PropTypes.array,
			selected: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _SiteFooter = SiteFooter;
	SiteFooter = _reactRedux.connect(function (state) {
		return {
			sections: state.navSections.data,
			isOpen: state.subscribeModal.isOpen
		};
	}, { open: _reduxModulesSubscribeModal.open })(SiteFooter) || SiteFooter;
	return SiteFooter;
})(_react.Component);

exports['default'] = SiteFooter;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SiteFooter/SiteFooter.js
 ** module id = 693
 ** module chunks = 0
 **/